// extracted by mini-css-extract-plugin
export default {"footer":"CheckoutFooter_footer__YKEbn"};